import "./Contact.css";

const Contact = () => {
  return (
    <section className="contact-section" id="contact">
      <video
    className="contact-video"
    autoPlay
    muted
    loop
    playsInline
>
    <source
        src={require("../assets/contact-video.mp4")}
        type="video/mp4"
    />
</video>

<div className="contact-overlay"></div>

      <div className="contact-header">
        <p className="contact-tag">CONTACT US</p>

        <h2 className="contact-title">
          Let's Build the Future Together
        </h2>

        <p className="contact-subtitle">
          Reach out to our engineering experts for consultancy,
          renewable energy solutions and power system studies.
        </p>
      </div>

      <div className="contact-container">

        <div className="contacts">

          <div className="contact-item">

            <img
              src="/ipr_logo.png"
              className="logo footer"
              alt="IPR Technologies"
            />

            <div className="contact-text-container">

              <h3 className="contact-name">
                IPR Technologies
              </h3>

              <p>📞 +91 9902668672</p>

              <p>✉ info@iprtechnologies.com</p>

              <p>
                📍 Ratna Vilas Road,
                Basavanagudi,
                Bengaluru,
                Karnataka
              </p>

            </div>

          </div>

        </div>

        <div className="map-container">

          <iframe
            title="IPR Technologies Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.522193356658!2d77.5729566759071!3d12.938402087373833!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae159225ff6609%3A0xa88390dbff573897!2sHonnam%20Complex%2C%20Basavanagudi%2C%20Bengaluru%2C%20Karnataka%20560004!5e0!3m2!1sen!2sin!4v1712413482409!5m2!1sen!2sin"
            className="map"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />

        </div>

      </div>

    </section>
  );
};

export default Contact;